

export class LocalStorage<T> {
  private key: string;

  constructor(key: string) {
    this.key = key;
  }

  save(data: T): void {
    try {
      localStorage.setItem(this.key, JSON.stringify(data));
    } catch (error) {
      console.error(`Error saving to localStorage: ${error}`);
    }
  }

  get(): T | null {
    try {
      const item = localStorage.getItem(this.key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error reading from localStorage: ${error}`);
      return null;
    }
  }

  update(updateFn: (prevData: T | null) => T): void {
    const currentData = this.get();
    const newData = updateFn(currentData);
    this.save(newData);
  }

  delete(): void {
    try {
      localStorage.removeItem(this.key);
    } catch (error) {
      console.error(`Error deleting from localStorage: ${error}`);
    }
  }
}


export const voiceModeLocalStorage = new LocalStorage('voiceMode');
